<template>
  <div class="loginapp">
    <div class="login-container">
      <div class="left-section">
        <div class="welcome-text">
          <h1>Hello!</h1>
          <p>欢迎来到中泽科教激光切割教育云平台</p>
          <p>Welcome to Nakazawa Laser Cutting Education cloud platform</p>
        </div>
        <div class="illustration">
          <img src="/img/login-2.png" alt="illustration" class="login-illustration-2">
          <img src="/img/login-1.png" alt="illustration" class="login-illustration-1">
        </div>
      </div>
      <div class="right-section">
        <div class="logo">
          <img src="/img/login-logo.png" alt="logo">
        </div>
        <div class="login-form">
          <h2>教师端登陆</h2>
          <el-form :model="form" ref="form" :rules="loginRules">
            <el-form-item prop="accountNumber">
              <el-input v-model="form.accountNumber" placeholder="邮箱" type="email"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="form.password" type="password" placeholder="密码"></el-input>
            </el-form-item>
            <div class="form-footer">
              <a class="forgot-password" @click="switchToReset">忘记密码?</a>
            </div>
            <el-form-item>
              <el-button type="primary" class="login-button" @click="handleLogin">登陆</el-button>
            </el-form-item>
            <div class="register-link">
              还没有账号？ <a @click="switchToRegister">立即注册</a>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  data() {
    return {
      isLogin: true, // 确保默认为登录状态
      isRegister: false,
      isResetPassword: false,
      sentCaptcha: '', // 用于存储发送的验证码
      form: {
        accountNumber: '',
        password: '',
        captcha: '',
        newPassword: '',
        confirmPassword: '',
        name: '',
        phone: '',
        inviteCode: '',
        agency: ''
      },
      loginRules: {
        accountNumber: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      registerRules: {
        accountNumber: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        inviteCode: [{ required: true, message: '请输入邀请码', trigger: 'blur' }],
        agency: [{ required: true, message: '请输入机构', trigger: 'blur' }]
      },
      resetPasswordRules: {
        accountNumber: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.form.newPassword) {
        callback(new Error('两次密码输入不一致'));
      } else {
        callback();
      }
    },
    switchToRegister() {
      this.isLogin = false;
      this.isRegister = true;
      this.isResetPassword = false;
    },
    switchToLogin() {
      this.isLogin = true;
      this.isRegister = false;
      this.isResetPassword = false;
    },
    switchToReset() {
      this.isLogin = false;
      this.isRegister = false;
      this.isResetPassword = true;
    },
    sendCaptcha() {
      const formData = new FormData();
      formData.append('to', this.form.accountNumber);
      // 发送 POST 请求
      request.post('/api/email/send', formData, {
        headers: {
          'Content-Type': 'multipart/form-data' // 设置 Content-Type
        }
      }).then(response => {
        this.sentCaptcha = response.data.data;
        this.$message.success('验证码已发送，请查看您的邮箱！');
      }).catch(error => {
        console.error('发送邮箱时出错:', error);
      });
    },
    handleLogin() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const loginData = {
            accountNumber: this.form.accountNumber,
            password: this.form.password
          };

          request.post('/api/auth/login', loginData)
            .then(response => {
              console.log('登录响应:', response);
              if (response.code === 0 && response.data) {
                const userData = response.data;
                console.log('用户数据:', userData);

                // 保存token
                localStorage.setItem('token', userData.token);

                // 保存完整的用户信息对象
                if (userData.teachUser) {
                  localStorage.setItem('userInfo', JSON.stringify(userData.teachUser));
                  // 为了兼容性，也单独保存一些常用字段
                  localStorage.setItem('userAccountNumber', userData.teachUser.accountNumber || '');
                  localStorage.setItem('username', userData.teachUser.userName || '');
                  localStorage.setItem('userInstitutionName', userData.teachUser.institutionName || '');
                } else {
                  console.warn('teachUser数据缺失:', userData);
                }

                this.$message.success('登录成功');
                this.$router.push('/index');
              } else {
                this.$message.error(response.msg || '登录失败');
              }
            })
            .catch(error => {
              console.error('登录失败:', error);
              this.$message.error(error.message || '登录失败');
            });
        }
      });
    },
    handleRegister() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.newPassword !== this.form.confirmPassword) {
            this.$message.error('两次输入的密码不一致');
            return;
          }

          const registerData = {
            accountNumber: this.form.accountNumber,
            password: this.form.newPassword,
            userName: this.form.name,
            institutionName: this.form.agency,
            invitationCode: this.form.inviteCode
          };

          request.post('/api/auth/register', registerData)
            .then(response => {
              console.log('注册响应:', response);
              this.$message.success('注册成功，请登录');
              this.switchToLogin();
            })
            .catch(error => {
              console.error('注册失败:', error);
              this.$message.error('注册失败');
            });
        }
      });
    },
    sendVerificationCode() {
      if (!this.form.accountNumber) {
        this.$message.error('请输入邮箱');
        return;
      }

      request.post(`/api/email/send?to=${this.form.accountNumber}`)
        .then(response => {
          console.log('验证码发送响应:', response);
          this.$message.success('验证码已发送到邮箱');
        })
        .catch(error => {
          console.error('验证码发送失败:', error);
          this.$message.error('验证码发送失败');
        });
    },
    async resetPassword() {
      const response = await request.post('/api/reset-password', {
        email: this.form.accountNumber,
        newPassword: this.form.newPassword,
        captcha: this.form.captcha
      });
      if (response.data.success) {
        this.$router.push('/index')
      }
      return response.data;
    }
  }
};
</script>

<style scoped>
.loginapp {
  width: 100vw;
  height: 100vh;
  display: flex;
  background: #fff;
}

.login-container {
  width: 100%;
  height: 100%;
  display: flex;
}

.left-section {
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
}

.left-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background: #1890FF; */
  clip-path: polygon(0 0, 100% 0, 80% 100%, 0% 100%);
  z-index: 0;
}

.welcome-text {
  position: relative;
  z-index: 99;
  padding: 60px;
  top: 50px;
  left: 100px;
  color: white;
  text-align:left;
}

.welcome-text h1 {
  font-size: 70px;
  margin-bottom: 20px;
}

.welcome-text p {
  font-size: 16px;
  line-height: 1.5;
  opacity: 1;
  
}

.illustration {
  position: relative;
  width: 100%;
  top: -305px;
  left: 0;
  height: 500px;
}

.login-illustration-2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 850px;
  height: auto;
  z-index: 1;
}

.login-illustration-1 {
  position: absolute;
  top: 450px;
  left: 100px;
  width: 600px;
  height: auto;
  z-index: 2;
}

.right-section {
  width: 600px;
  padding: 60px;
  margin-top: 100px;
  margin-right: 200px;
  display: flex;
  flex-direction: column;
}

.logo {
  position: absolute;
  top: 50px;
  right: 100px;
}

.logo img {
  height: 52px;
}

.login-form {
  margin-top: 100px;
  margin-right: 100px;
  z-index: 999;
}

.login-form h2 {
  font-size: 24px;
  margin-bottom: 40px;
  color: #333;
  font-weight: 500;
}

.el-input {
  margin-bottom: 10px;
  
}

.el-input :deep(.el-input__inner) {
  height: 40px;
  border-radius: 4px;
}

.form-footer {
  display: flex;
  justify-content: flex-end;
  margin: 10px 0 20px;
}

.forgot-password {
  color: #1890FF;
  font-size: 14px;
  cursor: pointer;
}

.login-button {
  width: 100%;
  height: 40px;
  background: #2EA2FA;
  border: none;
  border-radius: 4px;
  margin-bottom: 20px;
}

.register-link {
  text-align: center;
  color: #666;
  font-size: 14px;
}

.register-link a {
  color: #2EA2FA;
  cursor: pointer;
  text-decoration: none;
}

/* 小屏幕响应式样式 */
@media screen and (max-width: 1866px) {
  .illustration {
  top: -245px !important;
 
}
  .welcome-text {
    top: 30px;
    left: 20px;
  }

  .welcome-text h1 {
    font-size: 50px;
  }

  .illustration {
    top: -200px;
  }

  .login-illustration-2 {
    width: 650px !important;
  }

  .login-illustration-1 {
    width: 500px;
    top: 300px;
    left: 80px;
  }

  .right-section {
    width: 500px;
    margin-right: 100px;
  }

  .logo {
    right: 80px;
  }

  .login-form {
    margin-right: 80px;
  }
}

@media screen and (max-width: 1280px) {
  .welcome-text {
    top: 20px;
    left: 40px;
  }

  .welcome-text h1 {
    font-size: 45px;
  }

  .illustration {
    top: -150px;
  }

  .login-illustration-2 {
    width: 550px;
  }

  .login-illustration-1 {
    width: 400px;
    top: 300px;
    left: 60px;
  }

  .right-section {
    width: 450px;
    margin-right: 60px;
  }

  .logo {
    right: 60px;
  }

  .login-form {
    margin-right: 60px;
  }
}

@media screen and (max-width: 1024px) {
  .welcome-text h1 {
    font-size: 40px;
  }

  .illustration {
    top: -100px;
  }

  .login-illustration-2 {
    width: 450px;
  }

  .login-illustration-1 {
    width: 350px;
    top: 250px;
    left: 40px;
  }

  .right-section {
    width: 400px;
    margin-right: 40px;
  }

  .logo {
    right: 40px;
  }

  .login-form {
    margin-right: 40px;
  }
}
</style>
